import { Aggregator } from './aggregator';

export class Last extends Aggregator<number> {
  protected value: number | undefined = undefined;

  getAggregated(): number | undefined {
    return this.value;
  }

  reset(): void {
    this.value = undefined;
  }

  protected _add(stat: number): void {
    this.value = stat;
  }
}
